import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined'
import {
    Badge,
    IconButton,
    SvgIcon,
    Tooltip,
    useMediaQuery
} from '@mui/material'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import * as endpoints from '@/endpoints'
import { useNotificationSocket } from '@/features/dashboard/notifications/hooks/useNotificationSocket'
import { useNotificationsQuery } from '@/features/dashboard/notifications/hooks/useNotificationsQuery'
import { usePopover } from '@/hooks/usePopover'
import axios from '@/lib/axios'
import { NotificationsPopover } from './notifications-popover'

export const NotificationsButton = () => {
    const popover = usePopover()
    const queryClient = useQueryClient()
    const smUp = useMediaQuery((theme) => theme.breakpoints.up('sm'))

    const { data } = useNotificationsQuery()
    useNotificationSocket()

    const notifications = data?.results ?? []
    const unread = data?.counts?.unread_count ?? 0

    const archiveMutation = useMutation({
        mutationFn: (id) =>
            axios.post(endpoints.NOTIFICATION_ARCHIVE, { ids: [id] }),
        onSuccess: () =>
            queryClient.invalidateQueries({ queryKey: ['notifications'] })
    })

    const archiveAllMutation = useMutation({
        mutationFn: () => axios.post(endpoints.NOTIFICATION_ARCHIVE_ALL, {}),
        onSuccess: () =>
            queryClient.invalidateQueries({ queryKey: ['notifications'] })
    })

    return (
        <>
            <Tooltip title="Notifications">
                <IconButton
                    ref={popover.anchorRef}
                    onClick={popover.handleOpen}
                    size={smUp ? 'large' : 'small'}
                >
                    <Badge color="error" badgeContent={unread}>
                        <NotificationsNoneOutlinedIcon
                            fontSize={smUp ? 'large' : 'small'}
                        />
                    </Badge>
                </IconButton>
            </Tooltip>
            <NotificationsPopover
                anchorEl={popover.anchorRef.current}
                notifications={notifications}
                onClose={popover.handleClose}
                onMarkAllAsRead={() => archiveAllMutation.mutate()}
                onRemoveOne={(id) => archiveMutation.mutate(id)}
                open={popover.open}
            />
        </>
    )
}
